import { useState } from "react";
import { message } from "antd";
import { PrintScanBtn, ScanContainerBtn } from "./ScanContainerDispatch.style";
import BarcodeScanner from "../../BarcodeScanner/BarcodeScanner";
import { selectPrinterByDesk } from "../../helper/deskData";
import { connect } from "react-redux";
import { DEFAULT_DESK } from "../../../constants";
import PackSlipPrint from "../PackSlipPrint";
import {
  generateInvoicePdf,
  printPdfApi,
} from "../../../services/packslip.service";
import { BsUpcScan } from "react-icons/bs";

const ScanContainerDispatch = (props) => {
  const { currDesk, deskData } = props;
  const [showScanner, setShowScanner] = useState(false);
  const [tempInvoiceLink, setTempInvoiceLink] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [currBoxNumber, setCurrBoxNumber] = useState(null);
  const [loading, toggleLoading] = useState(false);

  const handlePrint = async (params) => {
    const { boxNumber } = params || {};
    setShowScanner(false);
    try {
      if (!currDesk) {
        message.error("Please select a desk to print the invoice", 2);
      } else {
        toggleLoading(true);

        const { responseData: invoiceGenerated } = await generateInvoicePdf({
          boxNumber,
        });

        if (invoiceGenerated) {
          setCurrBoxNumber(boxNumber);
          setShowPreview(true);
          setTempInvoiceLink(invoiceGenerated);
          toggleLoading(false);
        }
      }
    } catch (error) {
      message.error(error.message || "Internal Server Error");
      toggleLoading(false);
    }
  };

  const clearFunc = () => {
    toggleLoading(false);
    setShowPreview(false);
    setTempInvoiceLink(false);
    setCurrBoxNumber(false);
  };

  const printSlipCall = async () => {
    toggleLoading(true);

    let printerDetails = {
      printerId: selectPrinterByDesk(deskData, currDesk),
      contentType: "pdf_uri",
      content: tempInvoiceLink,
      title: currBoxNumber + " - Invoice",
      source: "Checker",
    };
    await printPdfApi(printerDetails);
    toggleLoading(false);
    message.success("Done");
    clearFunc();
  };

  return (
    <>
      <PrintScanBtn className="bbtn" onClick={() => setShowScanner(true)}>
        <BsUpcScan /> Scan Container
      </PrintScanBtn>

      {showScanner && (
        <BarcodeScanner
          scan={showScanner}
          camera={showScanner}
          history={props.history}
          redirect="packslip"
          printPackSlip={handlePrint}
          getBoxId={() => setShowScanner(false)}
          closable
        />
      )}
      <PackSlipPrint
        showPreview={showPreview}
        closePreview={() => setShowPreview(false)}
        tempInvoiceLink={tempInvoiceLink}
        printSlipCall={printSlipCall}
        loading={loading}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  deskData: state.newCheckerOrderReducer.deskDetails?.deskDetailsList,
  currDesk: state.statusReducer?.deskNumber || DEFAULT_DESK,
});

export default connect(mapStateToProps, null)(ScanContainerDispatch);
